export default "__VITE_ASSET__wBofMRc7__"